import * as React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { getStyle } from './getStyle';

export function getKatalog(bookmarks: any): JSX.Element {
    // console.log(pageNumbers);
    return <View>
        <Text style={{ ...getStyle('h1'), marginTop: 0, marginBottom: '20pt' }}>Inhalt</Text>
        {Object.keys(bookmarks).map((key: string, idx: number) =>
            <View
                key={`catalog_${idx}`}
                style={{ ...getStyle(bookmarks[key].level === 1 ? 'katalog_l1' : bookmarks[key].level === 2 ? 'katalog_l2' : null) }}
            >
                <View style={{
                    display: 'flex', flexDirection: 'row', width: '460pt',
                    ...(bookmarks[key].level > 1 ? { paddingLeft: '20pt' } : {})
                }}>
                    <Text>{key}</Text>
                    <Text style={{ flex: 1, margin: '0 5pt', borderBottom: '1pt dotted #000', height: '9pt' }}></Text>
                </View>
                <Text>{bookmarks[key].page}</Text>
            </View>
        )}
    </View>;
}